import { interfaces } from "inversify/lib/interfaces/interfaces";

export class DIAlreadyOverriddenError extends Error {

  constructor({ target, overrideResult, existedOverrideVariant }: {
    target: interfaces.Newable<any>; overrideResult: interfaces.Newable<any>; existedOverrideVariant: interfaces.Newable<any>;
  }) {
    super(`${target} already overridden by ${overrideResult} (try ${existedOverrideVariant})`);

    Object.setPrototypeOf(this, new.target.prototype);
  }

}
